<template>
    <div class="flex items-center">
        <StarIcon
            v-for="fullStar in fullStars"
            :key="fullStar"
            class="shrink-0 h-5 w-5 text-amber-400"
            aria-hidden="true"
        />
        <svg
            v-for="halfStar in halfStars"
            :key="halfStar"
            class="shrink-0 h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="url(#halfStarGradient)"
            aria-hidden="true"
        >
            <linearGradient
                id="halfStarGradient"
                x1="0"
                x2="100%"
                y1="0"
                y2="0"
            >
                <stop offset="50%" stop-color="#FCBF24" />
                <stop offset="50%" stop-color="#E5E7EB" />
            </linearGradient>
            <path
                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
            />
        </svg>
        <StarIcon
            v-for="emptyStar in emptyStars"
            :key="emptyStar"
            class="shrink-0 h-5 w-5 text-gray-200"
            aria-hidden="true"
        />
    </div>
</template>

<script setup lang="ts">
import { StarIcon } from "@heroicons/vue/solid";

const props = defineProps<{
    rating: number;
}>();

const roundedRating = Math.round(2 * props.rating) / 2;
const fullStars = Math.floor(roundedRating);
const halfStars = (roundedRating % 1) * 2;
const emptyStars = 5 - fullStars - halfStars;
</script>
